export default __webpack_public_path__ + "static/media/speed.3dfbb8b5.svg";